import { Stack } from '@mui/material'
import TableContacts, { TableDocuments } from './Table'

const Documents = () => {
  return (
    <Stack gap={2}>
      <TableDocuments />
      <TableContacts />
    </Stack>
  )
}

export default Documents